import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'

import {searchService} from 'services'
import requestHandler from 'utils/requestHandler'
import {NavIcon} from 'components/CustomIcons'
import BButton from 'components/Form/Fields/BButton'

const CategorySubItem = ({e, i, isOpenItem}) => (
  <div className={'cats-subItem' + (isOpenItem === i ? ' cats-subItemOpen' : '')}>
    <ul>
      {e.children.map(e => (
        <li key={e.uuid}>
          <Link to={`/category/${e.alias}`}>{e.name}</Link>
        </li>
      ))}
    </ul>
  </div>
)

const CategoryItem = ({e, i, isOpenItem, setOpenItem}) => (
  <li onMouseOver={() => setOpenItem(i)}>
    <Link to={`/category/${e.alias}`} className={(isOpenItem === i ? ' cats-parentCatFocused' : '')}>
      <img alt='' src={'data:image/svg+xml;base64,' + e.image}/> <span>{e.name}</span>
    </Link>
  </li>
)


const ProductCategories = ({history, t}) => {
  const [data, setData] = useState(undefined)
  const [isOpen, setOpen] = useState(false)
  const [isOpenItem, setOpenItem] = useState(false)

  useEffect(() => {
    requestHandler(searchService.categories, 'json')
      .then(r => {
        if (r.success) setData(r.data ?? null)
      })

    document.body.addEventListener('click', e => {
      if (e.target !== document.getElementById('cats-openButton')) {
        toggleModal(false)
      }
    })
  }, [])

  React.useEffect(() => {
    history.listen(() => toggleModal(false))
  }, [history])

  const toggleModal = (value) => {
    setOpen(o => typeof value === 'boolean' ? value : !o)
    setOpenItem(false)
  }

  return (
    <div id='cats'>
      <BButton id='cats-openButton' white bordered onClick={toggleModal} focused={isOpen}>
        <NavIcon/>
        <span> {t('PRODUCT CATEGORIES')}</span>
      </BButton>

      <section id='cats-modal' className={(isOpen ? 'cats-modalOpen' : '') + (isOpenItem !== false ? ' cats-modalOpenSub' : '')}>
        {data ? (
          <>
            <div className='cats-parentCat'>
              <ul>
                {data.map((e, i) => <CategoryItem key={e.uuid} e={e} i={i} isOpenItem={isOpenItem} setOpenItem={setOpenItem}/>)}
              </ul>
            </div>
            <div className={'cats-sub' + (isOpenItem !== false ? ' cats-subOpen' : '')}>
              {data.map((e, i) => <CategorySubItem key={e.uuid} e={e} i={i} isOpenItem={isOpenItem}/>)}
            </div>
          </>
        ) : data === undefined ? (
          'loading...'
        ) : 'error'}
      </section>
    </div>
  )
}

export default ProductCategories
